import setMailboxJunkEmailConfigurationOperation from 'owa-service/lib/operation/setMailboxJunkEmailConfigurationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export default function saveMailboxJunkEmailConfiguration(options) {
    return setMailboxJunkEmailConfigurationOperation({
        Header: getJsonRequestHeader(),
        Options: options,
    });
}
//# sourceMappingURL=setMailboxJunkEmailConfiguration.js.map